export const environment = {
    name: 'production',
    production: true,
    apiConfiguration: {
        basePath: '/availability-calendar/api',
        paths: {
            config: '/config',
            calendar: '/calendar',
            translate: '/translate',
            pageKeyData: '/page-key-data/%s',
            logger: '/ui-log'
        }
    },
    comSharedApi: {
        basePath: '/com-shared/api',
        paths: {
            content: '/content/wdw/'
        }
    },
    analyticsServerPath: 'availability-calendar/analytics'
};
